import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from 'sweetalert2';
import { EstacionesTVADB } from 'src/app/DAO/EstacionesTVADB';
import { TblCatUsuario } from 'src/app/types/Tables';
import { MenuItem, SettingsCollection } from 'src/app/types/type';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { Oauth } from 'src/app/helpers/Oauth';
import { LoginService } from 'src/app/services/login.service';
import { Usuario } from 'src/app/types/Entitys';
import { catchError, switchMap, throwError } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login_okta.component.html',
  styleUrls: ['./login_okta.component.css']
})
export class LoginoktaComponent implements OnInit {
  respuesta: string = "";
  db: EstacionesTVADB;
  userSesion: TblCatUsuario;
  menus: any;
  flagLogin: boolean;

  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute,    
    private router: Router
  ) { }

  ngOnInit() {
    debugger
    this.route.queryParams.subscribe(params => {
      const code: string = params['code'];
      this.ingresarOkta(code);
    })
  }

  private ingresarOkta(code: string) {
    const body = {
      Code: code,
      Token: localStorage['acTkn'],
      IdTipoAplicacion: 1,
      IdEmpleado: 0
    };
    this.loginService.login(body)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.loginService.getSettings()
            .subscribe(async resp => {
              if (resp?.Result?.Exito) {
                const settings = resp.Result.Data as SettingsCollection
                const swalResp = await Swal.fire({
                  text: error.message,
                  allowEnterKey: false,
                  allowEscapeKey: false,
                  showConfirmButton: true,
                  allowOutsideClick: false
                })

                if (swalResp.value) {
                  const site = settings.login_UrlRedirect;
                  const endpoint = settings.login_Domain + settings.login_LogOut;
                  const id_Token = localStorage['acTkn_id'];
                  localStorage.clear();
                  Oauth.logout(site, endpoint, id_Token, '');
                }
              }
            })
          return throwError(() => new Error('!No se pudo iniciar sesión!'))
        })
      )
      .pipe(
        switchMap(
          async (resp) => {
            if (resp?.Result?.Exito) {
              const data = resp.Result.Data as Usuario;

              localStorage.jwt = data.Token;
              localStorage.IdEmpleado = data.IdEmpleado;
              localStorage.Browser = data.Browser;
              localStorage.Token = data.Token;
              localStorage.IpSesion = data.IpSesion;
              localStorage.Roles = JSON.stringify(data.Roles);
              localStorage.Rol = data.Roles[0].IdRol + '-' + data.Roles[0].Descripcion;

              this.db = new EstacionesTVADB();
              await this.db.postLocalobject('TblCatUsuario', data);

              return data.IdEmpleado;
            } else {
              if (resp.Result.ErrorCode.split('-')[0] === '1') {
                console.log(resp.Result.Error, resp.Result.ErrorCode);
                Utilerias.alertClient('', resp.Result.Error, 1);
              } else {
                throw resp.Result.Error;
              }
            }
          }
        )
      )
      .subscribe(idEmpleado => {
        this.loginService.getCatalogoMenus(idEmpleado)
          .subscribe(resp => {
            if (resp.Result.Exito) {
              const data = resp.Result.Data as MenuItem[]
              const page = data.length > 0 ? data[0] : null;

              this.router.navigate([`/${page.ComponentName}`]);
            }
          });
      })
  }
}
